import React from 'react';
import logo from '../../../assets/img/inviteFr.png';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
function Invite(props) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '70vh',
                padding: '8px 24px',
            }}
        >
            <div
                style={{
                    width: 320,
                    textAlign: 'center',
                }}
            >
                <img
                    src={logo}
                    alt="logo"
                    style={{
                        marginBottom: 30,
                    }}
                />
                <p
                    style={{
                        fontSize: 18,
                        fontWeight: 400,
                        color: '#fff',
                        fontFamily: 'PoppinsRegular',
                        marginBottom: 20,
                    }}
                >
                    Taffi is better with friends!
                </p>
                <button
                    style={{
                        background: '#4A6C72',
                        width: '320px',
                        height: '44px',
                        borderRadius: '42px',
                        textAlign: 'center',
                        border: 'none',
                        fontWeight: 400,
                        color: '#fff',
                        fontFamily: 'PoppinsRegular',
                        fontSize: 14,
                        marginBottom: 10,
                    }}
                >
                    <span>
                        <WhatsAppIcon style={{ color: 'white', marginRight: 10 }} />
                    </span>{' '}
                    WhatsApp
                </button>
                <button
                    style={{
                        background: '#4A6C72',
                        width: '320px',
                        height: '44px',
                        borderRadius: '42px',
                        textAlign: 'center',
                        border: 'none',
                        fontWeight: 400,
                        color: '#fff',
                        fontFamily: 'PoppinsRegular',
                        fontSize: 14,
                    }}
                >
                    <span>
                        <MailOutlineIcon style={{ color: 'white', marginRight: 10 }} />
                    </span>{' '}
                    SMS
                </button>
            </div>
        </div>
    );
}

export default Invite;
